<script>
export default {
  name: "ContentText",
  functional: true,
  render(h, { data, children }) {
    data.staticClass = `content-text ${data.staticClass || ""}`.trim();

    return h("div", data, children);
  }
};
</script>

<style lang="scss">
.content-text {
  color: colors(text-2);
  line-height: 1.5em;
  font-size: 1.0625rem; // 17px / 16px

  h2,
  h3,
  h4,
  h5,
  h6 {
    color: colors(text-3);
  }

  p {
    margin-bottom: 1.6875rem; // 27px / 16px
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 1.6875rem; // 27px / 16px
  }

  p,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &:last-child {
      margin-bottom: 0;
    }
  }

  h2 {
    font-size: 1.875rem; // 30px / 16px
    line-height: 1.875rem; // 30px / 16px
  }

  h3 {
    font-size: 1.75rem; // 28px / 16px
    line-height: 1.75rem;
  }
  h4 {
    font-size: 1.625rem; // 36px / 16px
    line-height: 1.625rem;
  }
  h5 {
    font-size: 1.375rem; // 22px / 16px
    line-height: 1.375rem; // 22px / 16px
  }
  h6 {
    font-size: 1.25rem; // 20px / 16px
    line-height: 1.25rem; // 20px / 16px
  }

  ul,
  ol {
    margin-block-start: 1em;
    margin-block-end: 1em;
    padding-inline-start: 40px;
  }
}
</style>
